import { render, staticRenderFns } from "./ProlongSubscriptionResolver.vue?vue&type=template&id=6aee378d&"
import script from "./ProlongSubscriptionResolver.vue?vue&type=script&lang=js&"
export * from "./ProlongSubscriptionResolver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports